import React, { VFC } from 'react';
import { useFormContext } from 'react-hook-form';

type TProps = {
  name: string;
  className?: string;
  labelTrue?: string;
  labelFalse?: string;
};

/**
 * !see https://www.figma.com/file/tDn9C162xYWTXkvFMaipAn/Final-Design-and-Design-system?node-id=1%3A429
 */
export const ToggleLabelButton: VFC<TProps> = ({
  name,
  className,
  labelTrue = 'YES',
  labelFalse = 'NO',
}) => {
  const methods = useFormContext();
  const { ref, ...rest } = methods.register(name);

  return (
    <div className={'flex items-center ' + className}>
      <div className="mr-8">
        <label className="mbx-formToggle mbx-formToggle-select">
          <input
            type="checkbox"
            {...rest}
            ref={(e: HTMLInputElement) => {
              ref(e);
              // textareaRef.current = e; // you can still assign to ref
            }}
          />
          <div className="mbx-formToggle-body">
            <p className="mbx-formToggle-true">{labelTrue}</p>
            <p className="mbx-formToggle-false">{labelFalse}</p>
          </div>
        </label>
      </div>
      <p className="text-14_21 whitespace-nowrap">入力代行された内容を反映（編集）する</p>
    </div>
  );
};
